
import PlayerControls from '@/components/PlayerControls.vue';
import MusicTree from './MusicTree.vue';
import MusicAlbumListing from './MusicAlbumListing.vue';
import MusicFooter from './MusicFooter.vue';

export default {
  setup() {
    return {};
  },
  components: {
    PlayerControls,
    MusicTree,
    MusicAlbumListing,
    MusicFooter
  }
};
